import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { XContestTypes } from 'src/redux/types/xContest'
import { action } from 'typesafe-actions'
import { ModalButton } from 'src/components/Global/Button/Button'
import { useTypedSelector } from 'src/redux/index'
import { Wrapper, ContestFormFreq } from './style'
import { CreateContestContainer } from '../createContest/style'
import { Link, useLocation } from 'react-router-dom'

const ContentSavingFreq = () => {
  let location = useLocation()
  const dispatch = useDispatch()
  const joinForm = useTypedSelector((state) => state.xcontest.joinForm)
  const allContest = useTypedSelector((state) => state.xcontest.all)
  const data = allContest.filter(
    (item: any) => item?.id === joinForm.contest_id
  )
  const [automatedChecked, setautomatedChecked] = useState(true)
  const [manualChecked, setmanualChecked] = useState(false)
  const [automated, setAutomated] = useState(true)
  const [planData, setPlanData] = useState({
    saving_type: '',
  })

  const { saving_type } = planData

  const handleautomatedOnChange = () => {
    setautomatedChecked(!automatedChecked)
    setmanualChecked(!manualChecked)
    planData.saving_type = 'automated'
    automatedChecked
      ? dispatch(action(XContestTypes.CONTEST_FORM_DATA, planData))
      : dispatch(action(XContestTypes.CONTEST_FORM_DATA, planData))
  }

  const handleManualOnChange = () => {
    setmanualChecked(!manualChecked)
    setautomatedChecked(!automatedChecked)
    setAutomated(!automated)
    planData.saving_type = 'manual'
    manualChecked
      ? dispatch(action(XContestTypes.CONTEST_FORM_DATA, planData))
      : dispatch(action(XContestTypes.CONTEST_FORM_DATA, planData))
  }
  const { name } = data[0]
  // const [manualSavingModal, setManualSavingModal] = useState(false)

  // const [joinSavingType, setJoinSavingType] = useState({
  //   saving_type: 'automated',
  //   saving_frequency: 'monthly',
  //   amount_to_save: '1000',
  // })

  // let { saving_type } = joinSavingType

  // console.log(joinSavingType, 'joinSavingType')

  // const handleFreqChange = () => {
  //   setManual(!manual)
  //   setAutomated(false)
  //   if (manual) {
  //     setJoinSavingType({
  //       ...joinSavingType,
  //       saving_type: 'manual',
  //     })
  //   }
  // }

  // const handleAutomatedClick = () => {
  //   setManual(false)
  //   setAutomated(true)
  // }

  const handleSubmit = (e: any) => {
    e.preventDefault()
  }

  const handleDispatch = () => {
    // dispatch(
    //   action(XContestTypes.CONTEST_FORM_DATA, {
    //     ...joinForm,
    //     saving_type: saving_type,
    //     saving_frequency: joinSavingType.saving_frequency,
    //   })
    // )
  }

  return (
    <Wrapper>
      <CreateContestContainer>
        <div className="name">
          <h2>{name}</h2>
        </div>
        <ContestFormFreq onSubmit={handleSubmit}>
          <div className="saving_freq_container">
            <p className="">How do you want your savings to be?</p>
            <div className="saving_freq_select">
              <div className="auto_select">
                <div className="frequency">
                  <label className="container">
                    Automated
                    <input
                      type="radio"
                      checked={automatedChecked}
                      name="saving_type"
                      value="saving_type"
                      onChange={handleautomatedOnChange}
                    />
                    <span className="checkmark"></span>
                  </label>
                  {automatedChecked && (
                    <Link
                      to={`/contest-frequency`}
                      state={{ backgroundLocation: location }}
                    >
                      <div className="reverse">Monthly(tap to change)</div>
                    </Link>
                  )}
                </div>
              </div>

              <div className="manual_select">
                <label className="container">
                  Manually
                  <input
                    type="radio"
                    checked={manualChecked}
                    name="saving_type"
                    value={saving_type}
                    onChange={handleManualOnChange}
                  />
                  <span className="checkmark"></span>
                </label>
              </div>
            </div>
          </div>
        </ContestFormFreq>
        <div className="btn_wrapper">
          <Link
            to={`/contest-checkout`}
            state={{ backgroundLocation: location }}
          >
            <ModalButton
              className="contest_proceed_btn"
              onClick={handleDispatch}
            >
              Proceed
            </ModalButton>
          </Link>
        </div>
      </CreateContestContainer>
    </Wrapper>
  )
}

export default ContentSavingFreq
